import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { matchRouteSeoRule } from './routeSeoConfig';
import { buildCanonicalHref } from './buildCanonicalHref';
import { getRssFeedUrl } from '../constants/rss';

export function RouteSeo() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const rule = matchRouteSeoRule(pathname);

  const pageTitle = t(rule.titleKey);
  const description = t(rule.descKey);
  const keywords = t(rule.keywordsKey);
  const brand = t('seo.brand');
  const documentTitle = rule.fullTitle ? pageTitle : `${pageTitle} · ${brand}`;

  const canonical = buildCanonicalHref(pathname);
  const htmlLang = i18n.resolvedLanguage ?? i18n.language;
  const rssUrl = getRssFeedUrl(htmlLang);

  return (
    <Helmet prioritizeSeoTags htmlAttributes={{ lang: htmlLang }}>
      <title>{documentTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonical} />
      {rssUrl ? (
        <link
          rel="alternate"
          type="application/rss+xml"
          title={t('rss.feedTitle')}
          href={rssUrl}
        />
      ) : null}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={documentTitle} />
      <meta property="og:description" content={description} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={documentTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
